import QueryString from 'query-string'
import { forEach, find, includes } from 'lodash'
import { renderMarkdown } from '../../util'


export const requestCobrand = () => {
    return (dispatch, getState) => {
        const state = getState()

        // Check the cobrand reducer has been added to the app reducers
        if(!state.cobrand) throw("You have not added the cobrand reducer")
      
        // The app has already loaded the cobrand data, so don't load it again
        if(state.cobrand.loaded) return

        // Get the reference code
        const query = QueryString.parse(QueryString.extract(window.location.href));
        const referenceCode = query.referenceCode;
        
        // If there is no referenceCode then we don't need to do anything
        if(!referenceCode) return;
        
        // Get the contentful client from the config
        const config = state.config;
        if(!config) throw("You have not provided a config")
        if(!config.project) throw("You have not specified the project in the config")

        const cobrand = state.cobrand;
        if(!cobrand ) throw("You have not initialised the cobrand module")
        
        // Make the request
        makeRequest(referenceCode.trim(), config, cobrand.client, dispatch)

        // Notify the app that the cobrand is being requested
        dispatch({
            type: "REQUEST_COBRAND"
        })

    }
}


const supplyCobrand = (data) => {
    console.log("Suplpy cobrand")
    console.log(data)
    return {
        type: "SUPPLY_COBRAND",
        data
    }
}


async function makeRequest(referenceCode, config, client, dispatch){
    // Make a request for the cobrand data
    var entries = await client.getEntries()

    try{
        forEach(entries.items, entry => {
            // First check to see that the ?referenceCode query param exists as an entry in contentful
            let entryHasReferenceId:boolean = entry.fields.referenceId && entry.fields.referenceId.toLowerCase() === referenceCode.toLowerCase();
            entryHasReferenceId = entryHasReferenceId || (entry.fields.alternatives && includes(entry.fields.alternatives.toLowerCase().split('\n'), referenceCode.toLowerCase()));
            
            if(entryHasReferenceId){
                // Check to see that the current project is relevant to the referenceCode
                const belongsToProject = find(entry.fields.products, product => product.fields.id == config.project);
                
                if( belongsToProject ){
                    // Supply the appropriate data to be persisted
                    dispatch( supplyCobrand({
                        referenceId: entry.fields.referenceId,
                        logoURL: entry.fields.logo.fields.file.url,
                        logoColouredURL: entry.fields.logoColoured ? entry.fields.logoColoured.fields.file.url : "",
                        products: entry.fields.products.map(product => ({  ...product.fields })),
                        url: entry.fields.url,
                        footer: {
                            __html: entry.fields.footer ? renderMarkdown( entry.fields.footer ) : null,
                        },
                    }))
                }
            }
        })
    }catch(e){
        // Don't handle the error       
    }
    
}


export default {
    requestCobrand
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/cobrand/cobrand-actions.ts